import styled from "@emotion/styled";
import theme from "../../theme";
import { memo } from "react";

const { md } = theme.screen;

interface Prop extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  width?: string;
  id?: string;
  name?: string;
  placeholder?: string;
  maxLength?: number;
}

export const TextInput = memo(
  ({
    value,
    onChange,
    width,
    id,
    name,
    placeholder,
    maxLength,
    ...inputProps
  }: Prop) => {
    return (
      <CustomInput
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        width={width}
        maxLength={maxLength}
        {...inputProps}
      />
    );
  }
);

const CustomInput = styled.input<{ width?: string }>`
  width: ${({ width }) => width};
  height: 50px;
  background: ${theme.color.white};
  border-radius: 3px;
  border: none;
  padding-left: 15px;
  padding-right: 15px;

  @media (max-width: ${md}px) {
    width: 100%;
    height: 30px;
    font-size: ${theme.fontSize.FONT_2};
  }
`;
